import { useState } from "react";
import { recurringApi } from "../api/recurring";
import { useQueryClient } from "@tanstack/react-query";

export const useMarkAsCompleted = ({ projectId, refetch }: { projectId: string | undefined, refetch: () => void }) => {

    const queryClient = useQueryClient();

    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState<boolean>(false);

    const [completeNotes, setCompleteNotes] = useState<string>("");

    const handleMarkAsCompleted = async (eventId: string, dueDate: string) => {
        if (completeNotes.trim() === "") {
            setError("Completion notes cannot be empty.");
            return;
        }
        setLoading(true);
        const payload = {
            "due_date": dueDate,
            "completion_notes": completeNotes
        };
        await recurringApi.completeRecurringTask({ projectId, taskId: eventId }, payload);

        queryClient.invalidateQueries({ queryKey: ["tasks"] });

        setCompleteNotes("");
        setLoading(false);
        setIsOpen(false);
        setError(null);
        refetch();
    };

    return {
        isOpen,
        setIsOpen,
        error,
        setError,
        loading,
        completeNotes,
        setCompleteNotes,
        handleMarkAsCompleted
    };

};